import Constants from 'expo-constants'

export type RelayablyMarketingProduct = {
  id: string
  name: string
  description: string
  displayPrice: string
  interval: 'month'
  features: string[]
  note?: string
  cta?: string
  highlight?: boolean
}

type RelayablyMarketingProductsResponse = {
  products: RelayablyMarketingProduct[]
}

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const resolveEnvValue = (key: 'EXPO_PUBLIC_RELAYABLY_API_URL' | 'EXPO_PUBLIC_API_URL') => {
  const extra = (Constants.expoConfig?.extra ?? {}) as Record<string, string | undefined>
  return extra[key]
}

const resolveRelayablyApiBaseUrl = () => {
  const explicit = resolveEnvValue('EXPO_PUBLIC_RELAYABLY_API_URL') || resolveEnvValue('EXPO_PUBLIC_API_URL')

  if (explicit) {
    return trimTrailingSlash(explicit).replace(/\/internal$/, '')
  }

  return 'http://127.0.0.1:3337'
}

export const relayablyPaymentsApi = {
  async listProducts(): Promise<RelayablyMarketingProduct[]> {
    const response = await fetch(`${resolveRelayablyApiBaseUrl()}/api/v1/payments/products`)

    if (!response.ok) {
      const body = (await response.json().catch(() => null)) as { error?: { message?: string } } | null
      throw new Error(body?.error?.message ?? 'Relayably could not load pricing right now.')
    }

    const payload = (await response.json()) as RelayablyMarketingProductsResponse
    return payload.products
  },
}
